<template>
  <div>
    <div class="breadcrumbWrapper">
      <b-breadcrumb :items="crumbs" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BreadcrumbComponent',
  computed: {
    crumbs() {
      const pathArray = this.$route.path.split('/')
      pathArray.shift()

      return pathArray.reduce((breadcrumbArray, path, idx) => {
        breadcrumbArray.push({
          path,
          to: breadcrumbArray[idx - 1] ? `${breadcrumbArray[idx - 1].to}/${path}` : `/${path}`,
          text: this.$i18n.t(this.$route.matched[idx].meta.breadcrumb) || path
        })
        return breadcrumbArray
      }, [])
    }
  }
}
</script>

<style scoped>
.breadcrumbWrapper {
  margin-bottom: 30px;
}

.breadcrumb {
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
}

.breadcrumb-item a {
  color: #ccc;
  text-decoration: none;
  font-weight: bold;
  font-size: 0.75rem;
}

.breadcrumb > li + li:before {
  color: #ccc;
  content: '/';
  font-weight: bold;
}

.breadcrumb > .active {
  color: darkgrey;
  font-weight: bold;
  font-size: 0.75rem;
}
</style>
